import { IconCheck } from '@components/icons';
import { ButtonComponent, CheckIconContainer } from './Button.styles';
import mixpanel from 'mixpanel-browser';
import { onlyText } from 'react-children-utilities';

export interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'outline' | 'thick' | 'done' | 'danger';
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  loading?: boolean;
  full?: boolean;
  noStylingHover?: boolean;
}

const Button = ({ children, disabled, onClick, className, variant, loading, full, noStylingHover }: ButtonProps) => {
  return (
    <ButtonComponent
      className={className}
      disabled={disabled}
      full={full}
      onClick={() => {
        const name = onlyText(children);
        // console.log('Button click event name:', name);
        mixpanel.track('ButtonClicked', { name });
        if (onClick) onClick();
      }}
      variant={variant}
      $loading={loading}
      noStylingHover={noStylingHover}
    >
      {variant === 'done' && (
        <CheckIconContainer>
          <IconCheck width={24} height={24} />
        </CheckIconContainer>
      )}
      {loading ? 'Loading...' : children}
    </ButtonComponent>
  );
};

export default Button;
